import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import {
    GuidedWorkflowStep,
    GuidedWorkflowSubcategory,
} from 'GuidedWorkflowsApp/ts/interfaces/guided-workflows.response';

/**
 *
 * Guided Workflows Steps Component
 * Display the steps of a guided workflow.
 *
 *
 * Input Properties:
 *   steps: list of GuidedWorkflowStep to display.
 *   subcategory: the GuidedWorkflowSubcategory the steps belong to.
 *   categoryTitle: the title of the category
 *
 */
@Component({
    standalone: false,
    selector: 'ycn-guided-workflows-steps',
    templateUrl: './guided-workflows-steps.template.html',
})
export class GuidedWorkflowsStepsComponent implements OnChanges {
    @Input({ required: true }) categoryTitle!: String;

    @Input({ required: true }) subcategory!: GuidedWorkflowSubcategory;

    @Input({ required: true }) steps!: GuidedWorkflowStep[];

    sanitizedSteps: GuidedWorkflowStep[] = [];

    constructor(private sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.steps) {
            this.sanitizedSteps = this.steps.map((step) => ({
                ...step,
                text_content: this.sanitizer.bypassSecurityTrustHtml(step.text_content) as string,
            }));
        }
    }
}
